import trashIcon from "../assets/trash.svg";
import equipment_1 from "../assets/Mask Group 121.png";
import editButton from "../assets/edit_button.svg";
import login_bg from "../assets/login_bg.png";
import ballyhoura_logo from "../assets/img/ballyhoura_icon.svg";
import LockIcon from "../assets/img/icons/lock_icon.svg";
import CategoriesIcon from "../assets/img/icons/categories_icon.svg";
import TrailIcon from "../assets/img/icons/trails_icon.svg";
import FilterIcon from "../assets/img/icons/filter_icon.svg";
import LogoutIcon from "../assets/img/icons/logout_icon.svg";
import PinIcon from "../assets/img/icons/pin_icon.svg";
import EditIcon from "../assets/img/icons/edit_icon.svg";
import RemoveIcon from "../assets/img/icons/remove_icon.svg";
import CloseIcon from "../assets/img/icons/close_icon.svg";
import bellIcon from "../assets/img/icons/bell.png";
import mapIcon from "../assets/mapJPEG.jpg";
import stayEatIcon from "../assets/stay_eat.svg";
import daysOutIcon from "../assets/days_out.svg";
import equipmentIcon from "../assets/equipments.svg";
import profileIcon from "../assets/profile.svg";
import activityIcon from "../assets/activity.svg";
import loader from "../assets/loader.gif";
import attractions_nearby_icon from "../assets/attractions_nearby.svg";
import emergency_numbers_icon from "../assets/emergency_number.svg";
import public_transport_icon from "../assets/public_transport.svg";
import bike_repar_icon from "../assets/bike_repair.svg";
import garages_icon from "../assets/garages.svg";

export const IMAGES={
    TRASH_ICON: trashIcon,
    EQUIPMENT_1 : equipment_1,
    EDIT_BUTTON: editButton,
    LOGIN_BG: login_bg,
    LOGO:ballyhoura_logo,
    LockIcon,
    FilterIcon,
    CategoriesIcon,
    TrailIcon,
    LogoutIcon,  
    Map : mapIcon,
    stayEatIcon,
    daysOutIcon,
    equipmentIcon,
    profileIcon,
    activityIcon,
    loader,
    attractions_nearby_icon,
    emergency_numbers_icon,
    public_transport_icon,
    bike_repar_icon,
    garages_icon
}

export const ICONS={
    PinIcon,
    EditIcon,
    CloseIcon,
    RemoveIcon,
    bellIcon 
}